import { useTranslation } from 'react-i18next';
import type { BatchStatusTab } from '../../hooks/useBatchesMain';

interface StatusTabsProps {
  activeTab: BatchStatusTab;
  onTabChange: (tab: BatchStatusTab) => void;
  counts?: Record<BatchStatusTab, number>;
  allTotal?: number;
}

const TABS: BatchStatusTab[] = ['all', 'active', 'blocked', 'expired', 'depleted'];

export const StatusTabs = ({ activeTab, onTabChange, counts, allTotal }: StatusTabsProps) => {
  const { t } = useTranslation('batchesModule');

  const getCount = (tab: BatchStatusTab): number => {
    if (tab === 'all') return allTotal ?? 0;
    return counts?.[tab] ?? 0;
  };

  return (
    <div className="flex bg-card-bg rounded-lg text-sm p-1 mb-4 overflow-x-auto scrollbar-hide light:border-card-border light:border">
      {TABS.map((tab) => {
        const isActive = tab === activeTab;
        const count = getCount(tab);

        return (
          <button
            key={tab}
            type="button"
            onClick={() => onTabChange(tab)}
            className={`px-3 py-1 rounded hover:bg-hover-press whitespace-nowrap flex items-center gap-1.5 ${isActive ? 'bg-hover-press' : ''}`}
          >
            <span>{t(`tabs.${tab}`)}</span>
            <span
              className={`text-xs px-1.5 py-0.5 rounded-full min-w-[20px] text-center ${
                isActive ? 'bg-primary/20 text-primary' : 'bg-muted text-muted-foreground'
              }`}
            >
              {count}
            </span>
          </button>
        );
      })}
    </div>
  );
};
